import { atom } from "jotai";
import { Run } from "@quantizr-engineering/common/types/run";

export interface RunState {
  loading: boolean;
  data: Run[] | null;
  lastFetched: number | null;
}

export const runsLoadingAtom = atom<boolean>(false);

export const runsErrorAtom = atom<string | null>(null);

export const runsAtom = atom<RunState>({
  loading: false,
  data: null,
  lastFetched: null,
});

export const selectedRunAtom = atom(null, (get, _set, id: number) => {
  const runs = get(runsAtom);
  return runs.data?.find((r) => r.id === id);
});
